import * as React from 'react';
import { useEffect } from 'react';
import { TileLayout } from '@progress/kendo-react-layout';
import { ArcGauge } from '@progress/kendo-react-gauges';
import { DashboardChart } from '../components/dashboard/DashboardChart';
import { DashboardGrid } from '../components/dashboard/DashboardGrid';
import { useLocation } from 'react-router-dom';
import { useGlobalState } from '../App.js';
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { ComboBox, DropDownList } from "@progress/kendo-react-dropdowns";
import { Switch } from "@progress/kendo-react-inputs";

const colors = [
  {
    color: '#0058e9',
  },
];

const ArcGaugeComponent = () => {
    const [value] = React.useState(50);

  const arcOptions = {
    value: value,
    colors,
  };
  const arcCenterRenderer = (value, color) => {
    return (
      <h3
        style={{
          color: color,
        }}
      >
        {value}%
      </h3>
    );
  };
  return <div style={{
    height: '150px',
  }}>
    <ArcGauge {...arcOptions} arcCenterRender={arcCenterRenderer} />
  </div>;
};



export const Dashboard = () => { 
    const [loginInfo, updateLoginInfo] = useGlobalState();
     const [layout, setLayout] = React.useState("stretched");
    const [dashboardData, setDashboardData] = React.useState({
        "numMessagesActive": 0,
        "totalNumMessages": 0,
        "numRoutesActive": 0,
        "totalNumRoutes": 0,
        "activeRouteDetails": "No Active Route Defined",
        "numCustomMessagesActive": 0,
        "totalNumCustomMessages": 0,
        "messages": {},
        "routes": {}
    });
  

    const setActiveMessageNone = () => {
        var tempData = dashboardData;
        tempData.numMessagesActive = 0;
        setDashboardData(tempData);

    }

  const handleReposition = (e) => {
    setData(e.value);
  };
   
 
    useEffect(() => {
        loadState();
    }, []);

    const loadState = () => { 
      
    }
  
  const [data, setData] = React.useState([
    {
      col: 1,
      colSpan: 3,
      rowSpan: 2,
    },
    {
      col: 1,
      colSpan: 2,
      rowSpan: 3,
    },
  ]);
  
    const tiles = [
        {
            defaultPosition: {
                col: 1,
                colSpan: 1,
                rowSpan: 1,
            },
            header: 'Active Pre-Recorded Messages',
            body: <div className="dashboard-card-content">
                <p className="dashboard-card-content-number green">{dashboardData.numMessagesActive}</p>
                <div>
                    <p className="footer">
                        Total Messages: {dashboardData.totalNumMessages}
                    </p>
                </div>
                <button
                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                 
                >
                    Change
                </button>
              
            </div>,

        },
        {
            defaultPosition: {
                col: 2,
                colSpan: 1,
                rowSpan: 1,
            },
            header: 'Active Custom Messages',
            body: <div className="dashboard-card-content">
                <p className="dashboard-card-content-number green">{dashboardData.numCustomMessagesActive}</p>
                <div>
                    <p className="footer">
                        Total Custom Messages: {dashboardData.totalNumCustomMessages}
                    </p>
                </div>
                <button
                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                 
                >
                    Change
                </button>
              
            </div>,
        },
        {
            defaultPosition: {
                col: 3,
                colSpan: 1,
                rowSpan: 1,
            },
            header: 'Active Call Routes',
            body: <div className="dashboard-card-content">
                <p className="dashboard-card-content-number orange">{dashboardData.numRoutesActive}</p>
                <div>
                    <p className="footer">
                        Current: {dashboardData.activeRouteDetails}
                    </p>
                </div>
                <button
                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                  
                >
                    Change
                </button>
               
            </div>,
        },
      
    ];
 
  return (
    <div>
      <div className="greeting">
              Hello again,
    </div>

    <TileLayout columns={4} items={tiles} rowHeight={430} />
  
    </div>
  );


  
};


